import { combineReducers } from 'redux';
import menus from 'common/components/beacon/store/slice';

export default combineReducers({
  menus
});
